import { useMemo } from 'react';
import { isFeatureEnabled } from 'owa-feature-flags';
import {
    BUTTON_WIDTH,
    CONTAINER_PADDING,
    MAX_VISIBLE_BUTTONS,
    MAX_VISIBLE_BUTTONS_NEW_LAYOUT,
} from '../constants/constants';

export default function useButtonGroupContainerStyle(
    visibleButtonsCount: number
): React.CSSProperties {
    return useMemo(() => {
        const effectiveCount = Math.max(1, visibleButtonsCount);
        const width = effectiveCount * BUTTON_WIDTH + CONTAINER_PADDING;
        const maxVisibleButtons = isFeatureEnabled('fwk-header-sync-button-and-cleanup')
            ? MAX_VISIBLE_BUTTONS_NEW_LAYOUT
            : MAX_VISIBLE_BUTTONS;

        return {
            flex: `0 2 ${width}px`, // No grow, can shrink, base width
            minWidth: `${BUTTON_WIDTH}px`, // Minimum width for at least one button
            maxWidth: `${maxVisibleButtons * BUTTON_WIDTH + CONTAINER_PADDING}px`, // Maximum based on button count
        };
    }, [visibleButtonsCount]);
}
